import React from "react";
import Accordion from "@/components/Accordion";
import Bookmark from "./Bookmark";
import Button from "@/components/Button";
import Cards from "@/components/Cards";
import DividerBar from "@/components/DividerBar";
import Heading from "@/components/Heading";
import InlineImage from "@/components/Image";
import Text from "@/components/Text";

const Aside = ({ alignAside, nested, menu }) => {
  return (
    <div
      className={`tps-aside grid-x tps-float-medium tps-float-${alignAside}`}
    >
      <div className="tps-aside-inner cell">
        {nested?.data?.attributes.components?.map((c, index) => {
          switch (c.__component) {
            case "page.text":
              return (
                <Text
                  key={index}
                  text={c?.text}
                  withinContainer={c?.withinContainer}
                  displayAsInlineBlock={c?.displayAsInlineBlock}
                  accordionHtmlHack={c?.accordionHtmlHack}
                />
              );
            case "page.heading":
              return (
                <Heading
                  alignTitle={c?.alignTitle}
                  hTitleLevel={c?.hTitleLevel}
                  hTitleSeparator={c?.hTitleSeparator}
                  key={index}
                  title={c?.title}
                  subtitle={c?.subtitle}
                  subtitleLevel={c?.subtitleLevel}
                  withinContainer={c?.withinContainer}
                />
              );
            case "page.accordion":
              return (
                <Accordion
                  id={index}
                  key={index}
                  title={c.title}
                  items={c.items}
                  menu={menu}
                  slideEffect={c.slideEffect}
                />
              );
            case "page.image":
              return (
                <InlineImage
                  image={c?.image?.data?.attributes}
                  key={index}
                  alignment={c?.alignment}
                  size={c?.size}
                  style={c?.style}
                />
              );
            case "page.bookmark":
              return <Bookmark key={index} name={c.name} />;
            case "page.divider-brick":
              return (
                <DividerBar
                  key={index}
                  size={c.size}
                  withoutMargins={c.withoutMargins}
                />
              );
            case "page.button":
              return (
                <Button
                  align={c.align}
                  buttonClasses={c?.buttonClasses}
                  buttonColor={c?.buttonColor}
                  buttonLarge={c?.buttonLarge}
                  buttonsPositioning={c?.buttonsPositioning}
                  contentBefore={c?.ContentBefore}
                  filled={c?.filled}
                  key={index}
                  menu={menu}
                  news={c?.news}
                  page={c?.page}
                  concert={c?.concert}
                  course={c?.course}
                  targetBlank={c?.targetBlank}
                  text={c.text}
                  url={c.url}
                  withinContainer={c?.withinContainer}
                />
              );
            case "page.cards":
              return (
                <Cards
                  cardsAlignCenter={c?.cardsAlignCenter}
                  cardsText={c?.cardsText}
                  cardsTitle={c.cardsTitle}
                  cardsTitleAlign={c?.cardsTitleAlign}
                  cardsTitleHeadingLevel={c?.cardsTitleHeadingLevel}
                  items={c.items}
                  key={index}
                  layout={c.layout}
                  menu={menu}
                  numTileColumns={c?.numTileColumns}
                  withinContainer={c?.withinContainer}
                />
              );
            default:
              return null;
          }
        })}
      </div>
    </div>
  );
};

export default Aside;
